module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuM4zml1AAAACTSURBVEhL7dC9CYAwEIbhpBGcxgWs3cBG3MDaRt3I1v0iR7ic+YGAfrHKC1cY8B44VSZt/IGnzbofbgogPlAAiQEwUoFsFcj2IzDOUwVSCTD03VeAfooHCFDabEtrrrNxQ99AgLIITwgBAEpOlIIAAGcROs8TAiIC8DAEQmKA36AILQoBOOLfnhcKJm+vgy5LpNQNPY9Qe1aboK4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/icons/attack-icon.png
// module id = 484
// module chunks = 0